'use strict';

angular.module('cgmemApp')
	.config(['$stateProvider', function ($stateProvider) {
		$stateProvider
			.state('authenticated.shop', {
				url: '/shop',
				templateUrl: 'app/accountShop/shopcontainer.html',
				abstract: true
			})
			.state('authenticated.shop.select', {
				url: '/select',
				templateUrl: 'app/accountShop/select.html',
				controller: 'SelectCtrl'
			})
			.state('authenticated.shop.policies', {
				url: "/policies",
				templateUrl: "app/accountShop/policies.html",
				controller: 'PoliciesCtrl'
			})
			.state('authenticated.shop.extras', {
				url: "/extras",
				templateUrl: "app/accountShop/extras.html",
				controller: 'ExtrasCtrl'
			})
			.state('authenticated.shop.confirm', {
				url: "/confirm",
				templateUrl: "app/accountShop/confirm.html",
				controller: 'ConfirmCtrl'
			})
			.state('authenticated.shop.noproducts', {
				url: "/noproducts",
				templateUrl: "app/accountShop/noproducts.html"
			})
			.state('authenticated.shop.pay', {
				url: "/pay",
				templateUrl: "app/accountShop/pay.html",
				controller: 'PayCtrl'
			})
			.state('authenticated.shop.receipt', {
				url: "/receipt",
				templateUrl: "app/accountShop/receipt.html",
				controller: 'ReceiptCtrl',
				params: {
					balanceForward: 0,
					orderNumber: '',
					transactions: [],
					closingBalance: ''
				}
			})
			.state('authenticated.shop.reserve', {
				url: "/reserve",
				templateUrl: "app/accountShop/reserve.html",
				controller: 'ReserveCtrl',
			})
			.state('authenticated.shop.passes', {
				url: '/passes',
				templateUrl: 'app/accountShop/passes.html',
				controller: 'PassesCtrl'
			});
	}]);
